// 动态导入图片，实现按需加载
type ImageImport = () => Promise<{ default: string | { src: string; }; }>;

interface IconConfig {
  default: ImageImport;
  gray?: ImageImport;
  on?: ImageImport;
  off?: ImageImport;
  colorfull?: ImageImport;
}

export const iconMap: Record<string, IconConfig> = {
  'account-card': {
    default: () => import('@/features/user-center/images/icon/account-card.png'),
    gray: () => import('@/features/user-center/images/icon/account-card-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/account-card-colorfull.png'),
  },
  'add': {
    default: () => import('@/features/user-center/images/icon/add.png'),
  },
  'address-book': {
    default: () => import('@/features/user-center/images/icon/address-book.png'),
  },
  'agent-fission': {
    default: () => import('@/features/user-center/images/icon/agent-fission.png'),
    gray: () => import('@/features/user-center/images/icon/agent-fission-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/agent-fission-colorfull.png'),
  },
  'area': {
    default: () => import('@/features/user-center/images/icon/area.png'),
  },
  'back': {
    default: () => import('@/features/user-center/images/icon/back.png'),
  },
  'bet-history': {
    default: () => import('@/features/user-center/images/icon/bet-history.png'),
  },
  'captcha': {
    default: () => import('@/features/user-center/images/icon/captcha.png'),
  },
  'checked': {
    default: () => import('@/features/user-center/images/icon/checked.png'),
  },
  'close': {
    default: () => import('@/features/user-center/images/icon/close.png'),
  },
  'close-circle': {
    default: () => import('@/features/user-center/images/icon/close-circle.png'),
  },
  'delete': {
    default: () => import('@/features/user-center/images/icon/delete.png'),
  },
  'dollar': {
    default: () => import('@/features/user-center/images/icon/dollar.png'),
  },
  'double-more': {
    default: () => import('@/features/user-center/images/icon/double-more.png'),
  },
  'game-history': {
    default: () => import('@/features/user-center/images/icon/game-history.png'),
    gray: () => import('@/features/user-center/images/icon/game-history-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/game-history-colorfull.png'),
  },
  'help': {
    default: () => import('@/features/user-center/images/icon/help.png'),
  },
  'history': {
    default: () => import('@/features/user-center/images/icon/history.png'),
  },
  'home': {
    default: () => import('@/features/user-center/images/icon/home.png'),
  },
  'info': {
    default: () => import('@/features/user-center/images/icon/info.png'),
  },
  'invite': {
    default: () => import('@/features/user-center/images/icon/invite.png'),
  },
  'language': {
    default: () => import('@/features/user-center/images/icon/language.png'),
  },
  'location': {
    default: () => import('@/features/user-center/images/icon/location.png'),
  },
  'lock': {
    default: () => import('@/features/user-center/images/icon/lock.png'),
  },
  'logout': {
    default: () => import('@/features/user-center/images/icon/logout.png'),
    gray: () => import('@/features/user-center/images/icon/logout-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/logout-colorfull.png'),
  },
  'mail': {
    default: () => import('@/features/user-center/images/icon/mail.png'),
  },
  'more': {
    default: () => import('@/features/user-center/images/icon/more.png'),
  },
  'music-off': {
    default: () => import('@/features/user-center/images/icon/music-off.png'),
  },
  'music-on': {
    default: () => import('@/features/user-center/images/icon/music-on.png'),
  },
  'network': {
    default: () => import('@/features/user-center/images/icon/network.png'),
  },
  'notify': {
    default: () => import('@/features/user-center/images/icon/notify.png'),
    gray: () => import('@/features/user-center/images/icon/notify-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/notify-colorfull.png'),
  },
  'phone': {
    default: () => import('@/features/user-center/images/icon/phone.png'),
  },
  'pwd-off': {
    default: () => import('@/features/user-center/images/icon/pwd-off.png'),
  },
  'pwd-on': {
    default: () => import('@/features/user-center/images/icon/pwd-on.png'),
  },
  'setting': {
    default: () => import('@/features/user-center/images/icon/setting.png'),
    gray: () => import('@/features/user-center/images/icon/setting-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/setting-colorfull.png'),
  },
  'sound-off': {
    default: () => import('@/features/user-center/images/icon/sound-off.png'),
  },
  'sound-on': {
    default: () => import('@/features/user-center/images/icon/sound-on.png'),
  },
  'transaction': {
    default: () => import('@/features/user-center/images/icon/transaction.png'),
  },
  'transaction-history': {
    default: () => import('@/features/user-center/images/icon/transactio-history.png'),
    gray: () => import('@/features/user-center/images/icon/transactio-history-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/transactio-history-colorfull.png'),
  },
  'vip-benefits': {
    default: () => import('@/features/user-center/images/icon/vIp-benefits.png'),
    gray: () => import('@/features/user-center/images/icon/vIp-benefits-gray.png'),
    colorfull: () => import('@/features/user-center/images/icon/vIp-benefits-colorfull.png'),
  },
  'wallet': {
    default: () => import('@/features/user-center/images/icon/wallet.png'),
  },
  'copy': {
    default: () => import('@/features/user-center/images/icon/copy.png'),
  },
  'inviter': {
    default: () => import('@/features/user-center/images/icon/inviter.png'),
  },
  'customer': {
    default: () => import('@/features/user-center/images/icon/customer-colorfull.png'),
    colorfull: () => import('@/features/user-center/images/icon/customer-colorfull.png'),
  },
  'customer-vip': {
    default: () => import('@/features/user-center/images/icon/customer-colorfull-vip.png'),
    colorfull: () => import('@/features/user-center/images/icon/customer-colorfull-vip.png'),
  },
};

export type IconName = keyof typeof iconMap;
export type IconStatus = 'default' | 'gray' | 'colorfull';
